import {createSlice} from '@reduxjs/toolkit';

export const APP_STORE_NAME = 'tasks';

const initialState = {
  taskList: [],
  taskLoader: true,
};

const userSlice = createSlice({
  name: APP_STORE_NAME,
  initialState,
  reducers: {
    setTaskLoader(state, {payload}) {
      state.taskLoader = payload
    },
    setTasksList(state, {payload}) {
      state.taskList = payload;
    },
  },
});

export const {actions, reducer} = userSlice;
